import { defineStore } from 'pinia';
import { reactive } from 'vue';

interface Favourites {
  [k: string]: Set<number>;
}

export const usePunterStore = defineStore('PunterStore', () => {
  const favourites: Favourites = reactive({
    tournaments: new Set<number>(),
    events: new Set<number>(),
    markets: new Set<number>(),
  });

  const clearFavourites = (): void => {
    favourites.tournaments.clear();
    favourites.events.clear();
    favourites.markets.clear();
  };

  return {
    favourites,
    clearFavourites,
  };
});
